import React, { useCallback, useState, useMemo } from 'react'
import styled, { css } from 'styled-components'
import { down } from 'styled-breakpoints'
import Accordion from '../common/Accordion'
import {
	faqData1,
	faqData2,
	faqData3,
	faqData4,
	faqData5,
	faqData6,
} from '../../lib/faqData'
import { TABLET } from '../../lib/constant'

const categories = [
	{ id: 1, name: '요금 및 결제' },
	{ id: 2, name: '주차 관련' },
	{ id: 3, name: '계정 관련' },
	{ id: 4, name: '보험' },
	{ id: 5, name: '고장' },
	{ id: 6, name: '서비스 이용' },
]

export default function FAQSection() {
	const [index, setIndex] = useState(1)

	const onClick = useCallback((id) => {
		setIndex(id)
	}, [])

	const faqData = useMemo(
		() =>
			({
				1: faqData1,
				2: faqData2,
				3: faqData3,
				4: faqData4,
				5: faqData5,
				6: faqData6,
			}[index]),
		[index]
	)

	return (
		<Section>
			<CategoryList>
				<>
					{categories.map((category) => (
						<Button
							key={category.id}
							selectd={index === category.id}
							onClick={() => onClick(category.id)}
						>
							{category.name}
						</Button>
					))}
					<div style={{ minWidth: 16 }} />
				</>
			</CategoryList>
			<AccordionWrapper>
				{faqData &&
					faqData.map(({ id, summary, details }) => (
						<Accordion key={id} summary={summary} details={details} />
					))}
			</AccordionWrapper>
		</Section>
	)
}

const Section = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 0 16px;
	margin-top: 72px;
	margin-bottom: 180px;
	${down(TABLET)} {
		margin-top: 32px;
		margin-bottom: 160px;
	}
`

const CategoryList = styled.div`
	align-self: flex-start;
	max-width: 780px;
	width: 100%;
	margin: 0 auto;
	display: flex;
	overflow-x: auto;
	white-space: nowrap;
	padding-bottom: 16px;
	padding-right: 16px;
	box-sizing: unset;
	&::-webkit-scrollbar {
		display: none !important;
	}
`

const AccordionWrapper = styled.div`
	max-width: 780px;
	width: 100%;
`

const Button = styled.button`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	appearance: none;
	border: 2px solid black;
	border-radius: 85px;
	background-color: white;
	padding: 10px 16px;
	font-size: 24px;
	line-height: 28px;
	font-weight: 500;
	cursor: pointer;

	${({ selectd }) =>
		selectd &&
		css`
			background-color: black;
			color: white;
		`}

	& + & {
		margin-left: 16px;
	}

	${down(TABLET)} {
		font-size: 12px;
		line-height: 16px;
	}
`
